import React from 'react';
import PropTypes from 'prop-types';
// import { HeaderWrapper } from './Header.styled';

const Header = () => (
   <div>
      <h1>Check the header Component</h1>
      <p>Changed Value</p>
      <h2>Tasks Pending:</h2>
      <ul>
         <li>Hotel Bill Sheet KT</li>
         <li>Auto Attendance Entry</li>
         <li>Hotel Stationary - Spring File, Stapler, paper Punch</li>
         <li>Leet Code registration and coding</li>
         <li>Kanmani Account Setup and learning roadmap</li>
         <li>Kanmani TNEA application important dates calendar</li>
      </ul>

   </div>
);

// Header.propTypes = {};

Header.defaultProps = {};

export default Header;
